'use client';
import { GetAllCategoriesResult } from '@/sanity.types';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { IoMdArrowDropdown } from 'react-icons/io';

export default function CategoryDropdown({
  optionsList,
  activeCategory,
}: {
  optionsList?: GetAllCategoriesResult;
  activeCategory?: string | null;
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(activeCategory);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleButtonClick = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleOptionClick = (option: string) => {
    setSelectedOption(option); // Update button text
    setIsDropdownOpen(false); // Close the dropdown
  };
  return (
    <div className="row justify-content-center">
      <div className="col">
        <div className="dropdown-container" ref={dropdownRef}>
          <button
            className="dropdown-button btn btn-secondary btn-lg"
            onClick={handleButtonClick}
          >
            <span className="button-text">{selectedOption}</span>
            <span className="arrow-icon">
              <IoMdArrowDropdown />
            </span>
          </button>
          {isDropdownOpen && (
            <ul
              className="dropdown-menu border-0"
              role="listbox"
              aria-label="Category options"
            >
              {optionsList?.map((option) => (
                <li key={option._id}>
                  <Link
                    href={'/case-studies/category/' + option.slug?.current}
                    onClick={() => {
                      if (!option.title) return;
                      handleOptionClick(option.title);
                    }} // Handle option selection
                    className="dropdown-item"
                  >
                    {option.title}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
